import styled from "styled-components";
import {IonPage} from "@ionic/react";

export const PageBox = styled(IonPage)`
    background-color: ${props => props.theme.colors.light};
    color: ${props => props.theme.colors.lightContrast};
`
